import React        from 'react';
import CSSModules   from 'react-css-modules';
import moment       from 'moment';

import CPDTime      from '../CPDTime';
import ButtonLink   from '../ButtonLink';

import eventFormatter   from '../../services/eventFormatter';
import sessions         from "../../services/sessions";

import style from './style.scss';

class DetailPageHeader extends React.Component {

    _getTestimonialComponent(testimonial, key) {

        return (
            <div key={ key } styleName="testimonial">

                <div dangerouslySetInnerHTML={{ __html: testimonial.content }}
                     styleName="testimonial-content">
                </div>

                <span styleName="testimonial-author">
                    { testimonial.author_name }, { testimonial.organisation_name }
                </span>
            </div>
        )
    }

    _getFeaturedTestimonial() {

        if (this.props.featuredTestimonial) {

            return this._getTestimonialComponent(this.props.featuredTestimonial);
        }
    }

    _getFullyBookedMessage(viewport = 'browser') {
        if (this.props.isFullyBooked) {

            if(this.props.formattedEvent.multiple_days && this._firstDatePassed()) {
                return (
                    <span styleName={viewport === 'mobile' ? `already-started-mobile` : `already-started`} style={this._getModuleColorStyle()}>
                        This event has <br/>already started
                    </span>
                );
            } else {
                return (
                    <span className={style['fully-booked']} style={this._getModuleColorStyle()}>
                        This event is now <br/>fully booked
                    </span>
                );
            }
        }

        return null;
    }

    _getAlreadyStartedMessage(viewport = "browser") {
         return (
            <span styleName={viewport === 'mobile' ? `already-started-mobile` : `already-started`} style={this._getModuleColorStyle()}>
                This event has <br/>already started
            </span>
        );
    }

    _getBookingButton() {
        if (this.props.showBookingButton) {

            const bookingLink = this.props.buttonLink;

            if (!this.props.isELearningCourse) {
                if (this.props.formattedEvent && this.props.formattedEvent.multiple_days && this._firstDatePassed()) {
                    return (
                        this._getAlreadyStartedMessage()
                    )
                } else {
                    return (
                        <div className={style['booking-button']}>

                            <ButtonLink
                                to={bookingLink}
                                style={this._getModuleBackgroundStyle()}
                            >
                                Book Now
                            </ButtonLink>


                            {this._getFullyBookedMessage()}

                        </div>
                    )
                }
            } else {
                return (
                    <div className={style['booking-button']}>

                        <ButtonLink
                            to={bookingLink}
                            style={this._getModuleBackgroundStyle()}
                        >
                            Book Now
                        </ButtonLink>


                        {this._getFullyBookedMessage()}

                    </div>
                )
            }
        } else {
            if (!this.props.isELearningCourse) {
                if (this.props.formattedEvent && this.props.formattedEvent.multiple_days && this._firstDatePassed()) {
                    return (
                        this._getAlreadyStartedMessage()
                    );
                } else {
                    {this._getFullyBookedMessage()}
                }
            } else {
                {this._getFullyBookedMessage()}
            }
        }

        return null;
    }

    _getMobileBookingButton() {
        if (this.props.showBookingButton) {

            const bookingLink = this.props.buttonLink;

            if (!this.props.isELearningCourse) {

                if (this.props.formattedEvent && this.props.formattedEvent.multiple_days && this._firstDatePassed()) {
                    return (
                        this._getAlreadyStartedMessage('mobile')
                    )
                } else {
                    return (
                        <div className={style['booking-button-mobile']}>

                            <ButtonLink
                                to={bookingLink}
                                style={this._getModuleBackgroundStyle()}
                            >
                                Book Now
                            </ButtonLink>

                            {this._getFullyBookedMessage('mobile')}

                        </div>
                    )
                }
            } else {
                return (
                    <div className={style['booking-button-mobile']}>

                        <ButtonLink
                            to={bookingLink}
                            style={this._getModuleBackgroundStyle()}
                        >
                            Book Now
                        </ButtonLink>

                        {this._getFullyBookedMessage('mobile')}

                    </div>
                )
            }

        } else {

            if (!this.props.isELearningCourse) {

                if (this.props.formattedEvent && this.props.formattedEvent.multiple_days && this._firstDatePassed()) {
                    return (
                        this._getAlreadyStartedMessage('mobile')
                    );
                } else {
                    {this._getFullyBookedMessage('mobile')}
                }
            } else {
                {this._getFullyBookedMessage('mobile')}
            }
        }

        return null;
    }

    _getCPDTimeSummary() {

        if (this.props.cpdHours && this.props.cpdMinutes) {

            let cpdStyle = this._getModuleBackgroundStyle();

            if (this.props.isFullyBooked) {
                cpdStyle = { backgroundColor: '#cccccc' };
            }

            return (
                <CPDTime
                    hours={ this.props.cpdHours }
                    minutes={ this.props.cpdMinutes }
                    style={ cpdStyle }
                />
            );
        }
    }

    _getModuleBackgroundStyle() {

        if (this.props.moduleHexColor) {

            return {
                backgroundColor: this.props.moduleHexColor
            }
        }

        return null;
    }

    _getModuleBackgroundImage() {

        let className = '';

        if (this.props.courseType === 'online') {
            className = 'page-icon--online';
        } else if (this.props.courseType === 'classroom') {
            className = 'page-icon--course';
        } else if (this.props.courseType === 'conference') {
            className = 'page-icon--conference';
        } else if (this.props.courseType === 'webinar') {
            className = 'page-icon--webinar';
        }

        return <div className={style[className]} style={this._getModuleBackgroundStyle()} />
    }

    _getModuleColorStyle() {

        if (this.props.moduleHexColor) {

            return {
                color: this.props.moduleHexColor
            }
        }

        return null;

    }

    _getBoxTitle(title) {

        if (title) {

            let cpdStyle = this._getModuleColorStyle();

            if (this.props.isFullyBooked) {
                cpdStyle = { color: '#cccccc' };
            }

            return (
                <h3 className={style['box-title']} style={ cpdStyle }>
                    {title}
                </h3>
            )
        }

        return null;
    }

    _getEventDate(event) {

        if (event) {
            return (
                <div>
                    <span className={style['event-content-date']}>
                        {eventFormatter.getFormattedEventDate(event)}
                    </span>
                    <span className={style['event-content-time']}>
                        {eventFormatter.getFormattedEventStartTime(event)}&ndash;{eventFormatter.getFormattedEventEndTime(event)}
                    </span>
                </div>
            )
        }

        return null;
    }

    _firstDatePassed() {
        const firstDay = this.props.formattedEvent.multiple_days_events[0].start_date;

        return moment(firstDay).isBefore(moment.now());
    }

    _scrollToSchedule() {

        document
            .getElementById('event-summary')
            .scrollIntoView({
                behavior: 'smooth'
            });
    }

    render() {

        return (
            <div>
                <div className={style['header-box-top']}>
                    <div className={style['course-box']} style={ this._getModuleBackgroundStyle() } >
                        { this._getModuleBackgroundImage() }
                    </div>

                    <div className={style['course-title-box']}>
                        <h2 className={style['course-title']} style={ this._getModuleColorStyle() }>{ this.props.moduleName }</h2>
                        <h1 className={style['course-title']}>{ this.props.courseName }</h1>
                    </div>
                </div>

                <div className={style['header-box']}>

                    <div className={style['testimonial-box']}>
                        <div className={style['testimonial-content']}>
                            <span className={style['quote-icon']}>“</span>
                            { this._getFeaturedTestimonial() }
                        </div>
                    </div>

                    <div className={style['mobile-event-details']}>

                        <div className={style['summary-box-mobile']}>
                            <div className={style['event-summary']}>

                                {this.props.formattedEvent && this._getBoxTitle('Event') }

                                {this.props.isELearningCourse && this._getBoxTitle('Course Cost') }

                                {this.props.overriddenPrice !== null &&
                                <div className={style['cost-content']}>
                                    <span className={style['event-summary__info-line']}>&pound;{this.props.overriddenPrice} (+VAT)</span>
                                </div>
                                }

                                {this.props.isELearningCourse && this.props.overriddenPrice === null &&
                                <div className={style['cost-content']}>
                                    <span className={style['event-summary__info-line']}>Public Sector</span>
                                    <span className={style['event-summary__info-line']}>&pound;{ this.props.publicPrice } (+VAT)</span>

                                    <span className={style['event-summary__info-line']}>Private Sector</span>
                                    <span className={style['event-summary__info-line']}>&pound;{ this.props.privatePrice } (+VAT)</span>
                                </div>
                                }

                                {!this.props.formattedEvent && !this.props.isELearningCourse &&
                                <div>
                                    { this._getBoxTitle('Events') }

                                    <span>
                                        See <span className={style['schedule-link']} onClick={this._scrollToSchedule.bind(this)}>schedule</span> for upcoming dates for this course.
                                    </span>
                                </div>
                                }

                                {!this.props.isELearningCourse &&
                                <div
                                    className={!this.props.isFullyBooked ? style['event-content'] : style['event-content--fully-booked']}>

                                    {this.props.formattedEvent && this.props.formattedEvent.multiple_days && (
                                        this.props.formattedEvent.multiple_days_events.map((event_days) => {
                                            return (
                                                this._getEventDate(event_days)
                                            )
                                        })
                                    )}

                                    {this.props.formattedEvent && !this.props.formattedEvent.multiple_days && (
                                        this._getEventDate(this.props.formattedEvent)
                                    )}

                                    {this.props.courseType === "webinar" ? (
                                        <span className={style['event-content-location']}>
                                            Webinar
                                        </span>
                                    ) : (
                                        <span className={style['event-content-location']}>
                                            {this.props.shortLocation}
                                        </span>
                                    )}


                                </div>
                                }

                            </div>
                        </div>

                        <div className={style['summary-box-mobile']}>
                            <div className={!this.props.isFullyBooked ? style['cost-summary'] : style['cost-summary--fully-booked']}>

                                { !this.props.isELearningCourse && this._getBoxTitle('Cost') }
                                { this.props.isELearningCourse && this._getBoxTitle('Module Cost') }

                                {this.props.isELearningCourse && this.props.overriddenPrice !== null &&
                                <div className={style['cost-content']}>
                                    <span className={style['event-summary__info-line']}>
                                        Not applicable for this course.
                                    </span>
                                </div>
                                }

                                {this.props.overriddenPrice === null &&
                                <div className={style['cost-content']}>
                                    <span className={style['event-summary__info-line']}>Public Sector</span>
                                    <span
                                        className={style['event-summary__info-line']}>&pound;{this.props.isELearningCourse ? '25.00' : this.props.publicPrice} (+VAT)</span>

                                    <span className={style['event-summary__info-line']}>Private Sector</span>
                                    <span
                                        className={style['event-summary__info-line']}>&pound;{this.props.isELearningCourse ? '25.00' : this.props.privatePrice} (+VAT)</span>

                                    {this.props.isELearningCourse &&
                                    <span>
                                        Discounts are available for multiple modules: for more details see 'Costs' below
                                    </span>
                                    }
                                </div>
                                }
                            </div>
                        </div>

                        <div className={style['summary-box-mobile']}>

                            <div className={style['cpd-summary']}>
                                { !this.props.isELearningCourse && this._getBoxTitle('CPD') }
                                { this.props.isELearningCourse && this._getBoxTitle('Course CPD') }

                                <div className={!this.props.isFullyBooked ? style['cpd-time-text'] : style['cpd-time-text--fully-booked']}>
                                    <span className={style['event-summary__cpd-line']}>{this.props.cpdHours} hours {this.props.cpdMinutes} minutes</span>
                                </div>

                            </div>
                        </div>

                        { this._getMobileBookingButton() }

                    </div>

                    <div className={style['summary-box']}>
                        <div className={style['event-summary']}>

                            {this.props.formattedEvent && this._getBoxTitle('Event') }

                            {this.props.isELearningCourse && this._getBoxTitle('Course Cost') }

                            {this.props.overriddenPrice !== null &&
                            <div className={style['cost-content']}>
                                <span className={style['event-summary__info-line']}>&pound;{this.props.overriddenPrice} (+VAT)</span>
                            </div>
                            }

                            {this.props.isELearningCourse && this.props.overriddenPrice === null &&
                                <div className={style['cost-content']}>
                                    <span className={style['event-summary__info-line']}>Public Sector</span>
                                    <span className={style['event-summary__info-line']}>&pound;{ this.props.publicPrice } (+VAT)</span>

                                    <span className={style['event-summary__info-line']}>Private Sector</span>
                                    <span className={style['event-summary__info-line']}>&pound;{ this.props.privatePrice } (+VAT)</span>
                                </div>
                            }

                            {!this.props.formattedEvent && !this.props.isELearningCourse &&
                                <div>
                                    { this._getBoxTitle('Events') }

                                    <p>
                                        See schedule for upcoming dates for this course.
                                    </p>
                                </div>
                            }

                            {!this.props.isELearningCourse &&
                                <div
                                    className={!this.props.isFullyBooked ? style['event-content'] : style['event-content--fully-booked']}>

                                    {sessions(this.props.formattedEvent, this._getEventDate)}

                                    {this.props.formattedEvent && !this.props.formattedEvent.multiple_days && (
                                        this._getEventDate(this.props.formattedEvent)
                                    )}

                                    {this.props.courseType === "webinar" ? (
                                        <span className={style['event-content-location']}>
                                            Webinar
                                        </span>
                                    ) : (
                                        <span className={style['event-content-location']}>
                                            {this.props.shortLocation}
                                        </span>
                                    )}

                                </div>
                            }

                            { this._getBookingButton() }
                        </div>
                    </div>

                    <div className={style['summary-box']}>
                        <div className={!this.props.isFullyBooked ? style['cost-summary'] : style['cost-summary--fully-booked']}>

                            { !this.props.isELearningCourse && this._getBoxTitle('Cost') }
                            { this.props.isELearningCourse && this._getBoxTitle('Module Cost') }

                            {this.props.isELearningCourse && this.props.overriddenPrice !== null &&
                            <div className={style['cost-content']}>
                                    <span className={style['event-summary__info-line']}>
                                        Not applicable for this course.
                                    </span>
                            </div>
                            }

                            {this.props.overriddenPrice === null &&
                            <div className={style['cost-content']}>
                                <span className={style['event-summary__info-line']}>Public Sector</span>
                                <span
                                    className={style['event-summary__info-line']}>&pound;{this.props.isELearningCourse ? '25.00' : this.props.publicPrice} (+VAT)</span>

                                <span className={style['event-summary__info-line']}>Private Sector</span>
                                <span
                                    className={style['event-summary__info-line']}>&pound;{this.props.isELearningCourse ? '25.00' : this.props.privatePrice} (+VAT)</span>

                                <br/>

                                {this.props.isELearningCourse &&
                                <span>
                                    Discounts are available for multiple modules: for more details see 'Costs' below
                                </span>
                                }
                            </div>
                            }
                        </div>

                    </div>

                    <div className={style['summary-box']}>

                        <div className={style['cpd-summary']}>
                            { !this.props.isELearningCourse && this._getBoxTitle('CPD') }
                            { this.props.isELearningCourse && this._getBoxTitle('Course CPD') }

                            <div className={!this.props.isFullyBooked ? style['cpd-time-text'] : style['cpd-time-text--fully-booked']}>
                                <span className={style['event-summary__cpd-line']}>{this.props.cpdHours} hours {this.props.cpdMinutes} minutes</span>
                            </div>

                            <div className={style['cpd-summary-dotted_numbers']}>
                                {this._getCPDTimeSummary() }
                            </div>
                        </div>
                    </div>
                </div>

                <div className={style['course-header-box']}>
                        <h3 className={style['course-details']} style={ this._getModuleColorStyle() }>Details</h3>
                </div>
            </div>


        );
    }
}

export default CSSModules(DetailPageHeader, style);


// WEBPACK FOOTER //
// ./components/DetailPageHeader/index.js